import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const ApiCollectionEnvApi = createApi({
	reducerPath: "ApiCollectionEnvApi",
	baseQuery: fetchBaseQuery({
		baseUrl: import.meta.env.VITE_API_BASE_URL + "/env-mgmt",
		headers: {
			"Content-Type": "application/json",
			"x-api-key": import.meta.env.VITE_ENVIRONMENT_API_KEY,
			accessToken: localStorage.getItem("accessToken") || "",
		},
	}),
	tagTypes: ["environmentVariables"],
	endpoints: (builder) => ({
		// getEnvironmentByWorkspaceId: builder.query({
		//   query: ({ workspaceId, teamId }) =>
		//     `/appenvs?workspaceId=${workspaceId}&teamId=${teamId}`,
		// }),
		getEnvironmentByWorkspaceId: builder.query({
			query: ({ workspaceId }) => `/appenvs/workspace/${workspaceId}`,
		}),
		getEnvVariablesByEnvId: builder.query({
			query: (id) => `/appenvs/env/${id}?includingGlobal=true`,
		}),
		getEnvDetailsByEnvId: builder.query({
			query: (id) => `/appenvs/${id}`,
		}),
		getEnvVariablesListByEnvId: builder.query({
			query: ({ id }) => `/appenvs/env/${id}`,
		}),
		createEnvironment: builder.mutation({
			query: (body) => ({
				url: "/appenvs",
				method: "POST",
				body,
			}),
		}),
		duplicateEnvironment: builder.mutation({
			query: (body) => ({
				url: `/appenvs/${body.appEnvId}`,
				method: "POST",
				body,
			}),
		}),
		updateEnvironment: builder.mutation({
			query: (body) => ({
				url: `/appenvs/${body.appEnvId}`,
				method: "PUT",
				body: body,
			}),
		}),

		deleteEnvironment: builder.mutation({
			query: ({ appEnvId }) => ({
				url: `/appenvs/${appEnvId}`,
				method: "DELETE",
			}),
		}),

		activeEnvironments: builder.mutation({
			query: (body) => ({
				url: `/appenvs/${body.appEnvId}`,
				method: "PATCH",
				body: body,
			}),
		}),
		exportEnvironment: builder.query({
			query: ({ appEnvId }) => `/appenvs/export/env/${appEnvId}`,
		}),
		importEnvironment: builder.mutation({
			query: ({ workspaceId, body, envLevel, teamId }) => ({
				url: `/appenvs/import/workspace/${workspaceId}`,
				body: { ...body, envLevel, teamId },
				method: "POST",
			}),
		}),
		//variables
		createEnvVariables: builder.mutation({
			query: (body) => ({
				url: `/appenvs/variables`,
				method: "POST",
				body,
			}),
			invalidatesTags: ["environmentVariables"],
		}),
		updateEnvVariables: builder.mutation({
			query: (body) => ({
				url: `/appenvs/variables`,
				method: "PUT",
				body: body,
			}),
			invalidatesTags: ["environmentVariables"],
		}),

		deleteEnvVariable: builder.mutation({
			query: ({ appEnvVariableId }) => ({
				url: `/appenvs/variable/${appEnvVariableId}`,
				method: "DELETE",
			}),
		}),
	}),
});

export const {
	useGetEnvironmentByWorkspaceIdQuery,
	useGetEnvVariablesByEnvIdQuery,
	useGetEnvDetailsByEnvIdQuery,
	useGetEnvVariablesListByEnvIdQuery,
	useCreateEnvironmentMutation,
	useUpdateEnvironmentMutation,
	useDeleteEnvironmentMutation,
	useActiveEnvironmentsMutation,
	useDuplicateEnvironmentMutation,
	useExportEnvironmentQuery,
	useImportEnvironmentMutation,
	//Variables
	useCreateEnvVariablesMutation,
	useUpdateEnvVariablesMutation,
	useDeleteEnvVariableMutation,
} = ApiCollectionEnvApi;
